import { API_URL } from '../../../constants';
import { BrandCode } from '../../../shared/model/brand.model';


const DISTRIBUTION_LIST_GROUP_URL = `${API_URL}/distribution-list-groups`;

const paths = {
  getDistributionListGroups: (): string => `${DISTRIBUTION_LIST_GROUP_URL}`,
  getDistributionListGroupsByBrandAndRegionAndCountry: (
    brandCode: BrandCode,
    regionDescription: string,
    countryCode: string
  ): string => `${DISTRIBUTION_LIST_GROUP_URL}/${brandCode}?regionDescription=${regionDescription}&countryCode=${countryCode}`,
  postDistributionListGroup: (): string => `${DISTRIBUTION_LIST_GROUP_URL}`,
  putDistributionListGroup: (id: string): string => `${DISTRIBUTION_LIST_GROUP_URL}/${id}`,
  deleteDistributionListGroup: (id: string): string => `${DISTRIBUTION_LIST_GROUP_URL}/${id}`,
};

export default paths;